import host from './host.js';
import request from '../utils/request.js';

export function GetDiscountCategoryShopGoodList(data)
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetDiscountCategoryShopGoodList",
        method: "post",
        data
    } );
}

export function GetJiFenCategoryShopGoodList(data)
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetJiFenCategoryShopGoodList",
        method: "post",
        data
    } );
}

export function GetMMCShopGoodMoreList(data)
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetMMCShopGoodMoreList",
        method: "post",
        data
    } );
}

export function GetBDXCShopGoodMoreList(data)
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetBDXCShopGoodMoreList",
        method: "post",
        data
    } );
}

export function GetEvaluationByShopGoodsID(data)
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetEvaluationByShopGoodsID",
        method: "post",
        data
    } );
}

export function GetDiscountShopGoodList( data )
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetDiscountShopGoodList",
        method: "post",
        data
    } );
}

export function GetJiFenShopGoodList( data )
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetJiFenShopGoodList",
        method: "post",
        data
    } );
}

export function GetShopGoodListByCIDList( data )
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetShopGoodListByCIDList",
        method: "post",
        data
    } );
}

export function DiscountProductCategoryTree()
{
    return request(
    {
        url: host.test + "/Kitchen/ProductCategory/DiscountProductCategoryTree",
        method: "GET"
    } );
}

export function JiFenProductCategoryTree()
{
    return request(
    {
        url: host.test + "/Kitchen/ProductCategory/JiFenProductCategoryTree",
        method: "GET"
    } );
}

export function GetDiscountGood( id )
{
    return request(
    {
        url: host.test + "/Kitchen/ShopGoods/GetDiscountGood/" + id,
        method: "POST"
    } );
}